import { Table, Container, Button, Row, Col, Input } from 'reactstrap';
import React, { useEffect, useState } from 'react';
import {RiFileExcel2Line} from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
// import ReactTable from 'react-table';
// import ReactDOM from "react-dom"
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";
import "./Reports.css"
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report198() {
    pdfMake.fonts = {
        THSarabunNew: {
            normal: 'THSarabunNew.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNewn BoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-MediumItalic.ttf'
        }
    }

    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [othYearSelected, setOThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [Re198data, setRe198data] = useState([]);



    async function getR198() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        formData.append("othYear", othYearSelected);
        const res198 = await fetch("/api/BorrowReports/getV198", {
            method: 'POST',
            body: formData
        })
        const Re198data = await res198.json()
        setRe198data(Re198data.dataenum)
        console.log(Re198data)
    }

    const [Re198yeardata, setRe198yeardata] = React.useState([]);
    async function getR198year() {
        const res = await fetch("/api/BorrowReports/getyear198")
        const Re198yeardata = await res.json()
        setRe198yeardata(Re198yeardata.dataenum)
        console.log(Re198yeardata)
    }



    const y2 = Re198yeardata.filter(n => n.yearTh >= othYearSelected);

    // const PrintPDF = () => {
    //     var tablebody = [[{ text: 'ปีงบประมาณ', rowSpan: 3, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'ขนาดสถานประกอบกิจการที่กู้ยืมเงิน(จำนวนแห่ง)', colSpan: 3, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, {}, {}, { text: 'ลูกจ้างได้รับการพัฒนาฝีมือแรงงาน(จำนวนคน)', colSpan: 3, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, {}, {}, { text: 'ประเภทหลักสูตรการฝึกอบรม', colSpan: 6, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, {}, {}, {}, {}, {}],
    //         [{}, { text: 'ลูกจ้างต่ำกว่า100คน', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'ลูกจ้างมากกว่า100คน', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'รวม', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'ฝึกอบรม', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'ทดสอบ', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'รวม', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'หลักสูตรเฉพาะ', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'จำนวน(คน)', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'หลักสูตรทั่วไป', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'จำนวน(คน)', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'รวม', colSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, {}],
    //         [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, { text: 'หลักสูตร', fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'จำนวนคน', fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }]];
    //     Re198data.forEach(function (item) {
    //         var rowdata = [{ text: 'ปีงบประมาณ ' + item.budgetYear, alignment: 'left' }, { text: item.comLessThan100, alignment: 'right' }, { text: item.comMoreThan100, alignment: 'right' }, { text: item.sum1, alignment: 'right' }, { text: item.employeeTrain, alignment: 'right' }, { text: item.employeeTest, alignment: 'right' }, { text: item.sum2, alignment: 'right' }, { text: item.specificCouse, alignment: 'right' }, { text: item.specificEmployee, alignment: 'right' }, { text: item.normalCouse, alignment: 'right' }, { text: item.normalEmployee, alignment: 'right' }, { text: item.sum3, alignment: 'right' }, { text: item.sum4, alignment: 'right' }]
    //         tablebody.push(rowdata);
    //     });
    //     var docDefinition = {
    //         pageOrientation: 'landscape',
    //         content: [
    //             { text: 'สรุปข้อมูลการพัฒนาฝีมือแรงงากจากการกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน', style: 'header', bold: true, alignment: 'center', fontSize: 20 },
    //             { text: 'ปีงบประมาณ พ.ศ. ' + othYearSelected + ' ' + '-' + ' ' + thYearSelected, style: 'header', bold: true, alignment: 'center', fontSize: 16 },
    //             {
    //                 table: {
    //                     widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
    //                     body: tablebody
    //                 },
    //             }],

    //             defaultStyle: {
    //                 font: 'THSarabunNew'
    //             }
    
    //         }
    //         pdfMake.createPdf(docDefinition).download('R198')
    //     }


  



    useEffect(() => {
        getR198()
        getR198year()
    }, [thYearSelected, othYearSelected]);


    let sum1 = Re198data.reduce(function (prev, current) {
        return prev + +current.comLessThan100
    }, 0);
    let sum2 = Re198data.reduce(function (prev, current) {
        return prev + +current.comMoreThan100
    }, 0);
    let sum3 = Re198data.reduce(function (prev, current) {
        return prev + +current.sum1
    }, 0);
    let sum4 = Re198data.reduce(function (prev, current) {
        return prev + +current.employeeTrain
    }, 0);
    let sum5 = Re198data.reduce(function (prev, current) {
        return prev + +current.employeeTest
    }, 0);
    let sum6 = Re198data.reduce(function (prev, current) {
        return prev + +current.sum2
    }, 0);
    let sum7 = Re198data.reduce(function (prev, current) {
        return prev + +current.specificCouse
    }, 0);
    let sum8 = Re198data.reduce(function (prev, current) {
        return prev + +current.specificEmployee
    }, 0);
    let sum9 = Re198data.reduce(function (prev, current) {
        return prev + +current.normalCouse
    }, 0);
    let sum10 = Re198data.reduce(function (prev, current) {
        return prev + +current.normalEmployee
    }, 0);
    let sum11 = Re198data.reduce(function (prev, current) {
        return prev + +current.sum3
    }, 0);
    let sum12 = Re198data.reduce(function (prev, current) {
        return prev + +current.sum4
    }, 0);

    return (
        <Container>
            <div>
                {/* <div style={{ display: 'flex', paddingBottom: '20px', justifyContent: 'center' }}>
                    <h3 style={{ paddingTop: '2px' }} className='text-center'>
                        ปีงบประมาณ พ.ศ.
                    </h3>
                    <Input
                        style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                        id="othYear"
                        name="othYear"
                        type="select"
                        value={othYearSelected}
                        onChange={(e) => {
                            setOThYearSelected(e.target.value)
                        }}
                    >
                        {Re198yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                    <h3 style={{ lineHeight: 'inherit' }}>ถึง</h3>
                    <Input
                        style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {y2.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                </div> */}
                 <div className='d-flex justify-content-center align-items-center'>
                    <span className='header-select-year mx-3'>ประจำปีงบประมาณ พ.ศ.</span>
                    <Input
                        // className='report-select-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="othYear"
                        name="othYear"
                        type="select"
                        value={othYearSelected}
                        onChange={(e) => {
                            if(e.target.value !== "กรุณาเลือก"){
                                setOThYearSelected(e.target.value)
                            } else {
                                return;
                            }
                            
                        }}
                    >
                        <option disabled defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                        {Re198yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                        
                    </Input>
                    <span className='header-select-year mx-3'> ถึง </span>
                    <Input
                        // className='report-select-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            if(e.target.value !== "กรุณาเลือก"){
                                setThYearSelected(e.target.value)
                            } else {
                                return;
                            }
                            
                        }}
                    >
                        <option disabled defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                        {y2?.map((item, i) => (
                            <option className='option-style' value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                        
                    </Input>
                   
                </div>
                {/* <Row>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/BorrowReports/xlsxV198?thYear=${thYearSelected}&othYear=${othYearSelected}`} download>EXCEL</Button>
                        <Button className="btn2" href={`api/BorrowReports/pdfR198?thYear=${thYearSelected}&othYear=${othYearSelected}`} download>PDF</Button>
                    </Col>
                </Row> */}
                <Row className='my-3'>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn border border-1 mx-1 btn-green" href={`api/BorrowReports/xlsxV198?thYear=${thYearSelected}&othYear=${othYearSelected}`} download><RiFileExcel2Line/> Export Excel</Button>
                        <Button className="btn border border-1 mx-1 btn-red" href={`api/BorrowReports/pdfR198?thYear=${thYearSelected}&othYear=${othYearSelected}`} download><AiOutlineFilePdf/> Export PDF</Button>
                    </Col>
                </Row>

                <div className="report-wrapper">
                <Table className="styled-table text-center" bordered striped hover>
                    <thead className='styles-thead'>
                        <tr>
                            <th rowSpan="3" className=' text-center'>
                                ปีงบประมาณ
                            </th>
                            <th colSpan="3" className=' text-center'>
                                ขนาดสถานประกอบกิจการที่กู้ยืมเงิน (จำนวนแห่ง)
                            </th>
                            <th colSpan="3" className=' text-center'>
                                ลูกจ้างได้รับการพัฒนาฝีมือแรงงาน (จำนวนคน)
                            </th>
                            <th colSpan="6" className=' text-center'>
                                ประเภทหลักสูตรการฝึกอบรม
                            </th>

                            </tr>
                            <tr>
                                <th rowSpan="2" className='text-center'>
                                    ลูกจ้างต่ำกว่า 100 คน
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    ลูกจ้างมากกว่า 100 คน
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    รวม
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    ฝึกอบรม
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    ทดสอบ
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    รวม
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    หลักสูตรเฉพาะ
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    จำนวน (คน)
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    หลักสูตรทั่วไป
                                </th>
                                <th rowSpan="2" className='text-center'>
                                    จำนวน (คน)
                                </th>
                                <th colSpan="2" className=' text-center'>
                                    รวม
                                </th>

                        </tr>
                        <tr>
                            <th className='text-center'>
                                หลักสูตร
                            </th>
                            <th className='text-center'>
                                จำนวน(คน)
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {Re198data.length > 0 && Re198data.map((item, i) => (
                            <tr>
                                <td className='text-start'>
                                    {"ปีงบประมาณ" + ' ' + item.budgetYear}

                                </td>
                                <td className='text-end'>
                                    {item.comLessThan100}
                                </td>
                                <td className='text-end'>
                                    {item.comMoreThan100}
                                </td>
                                <td className='text-end'>
                                    {item.sum1}
                                </td>
                                <td className='text-end'>
                                    {item.employeeTrain}
                                </td>
                                <td className='text-end'>
                                    {item.employeeTest}
                                </td>
                                <td className='text-end'>
                                    {item.sum2}
                                </td>
                                <td className='text-end'>
                                    {item.specificCouse}
                                </td>
                                <td className='text-end'>
                                    {item.specificEmployee}
                                </td>
                                <td className='text-end'>
                                    {item.normalCouse}
                                </td>
                                <td className='text-end'>
                                    {item.normalEmployee}
                                </td>
                                <td className='text-end'>
                                    {item.sum3}
                                </td>
                                <td className='text-end'>
                                    {item.sum4}
                                </td>

                            </tr>
                        )) || <tr><td colSpan="13" rowSpan="6" className='text-center'>No Data</td></tr>}
                    </tbody>
                    <tfoot>
                        <tr>
                            <th scope="row" className='text-end'>
                                รวมทั้งสิ้น
                            </th>
                            <td className='text-end'>
                                {sum1}
                            </td>
                            <td className='text-end'>
                                {sum2}
                            </td>
                            <td className='text-end'>
                                {sum3}
                            </td>
                            <td className='text-end'>
                                {sum4}
                            </td>
                            <td className='text-end'>
                                {sum5}
                            </td>
                            <td className='text-end'>
                                {sum6}
                            </td>
                            <td className='text-end'>
                                {sum7}
                            </td>
                            <td className='text-end'>
                                {sum8}
                            </td>
                            <td className='text-end'>
                                {sum9}
                            </td>
                            <td className='text-end'>
                                {sum10}
                            </td>
                            <td className='text-end'>
                                {sum11}
                            </td>
                            <td className='text-end'>
                                {sum12}
                            </td>
                        </tr>
                    </tfoot>
                </Table>
                </div>

            </div>

        </Container>
    );


}